import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, Bookmark, CreditCard, User } from 'lucide-react';

export const BottomNav = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Inicio', icon: Home },
    { path: '/schedule', label: 'Horarios', icon: Calendar },
    { path: '/memberships', label: 'Planes', icon: CreditCard },
    { path: '/account', label: 'Cuenta', icon: User },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-t border-slate-100 md:hidden"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2 pb-safe">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`bottom-nav-item flex-1 ${active ? 'active' : ''}`}
              data-testid={`bottom-nav-${item.path.replace('/', '') || 'home'}`}
            >
              <div className={`nav-icon ${active ? 'bg-[#16263B] text-white' : ''}`}>
                <Icon className="w-5 h-5" strokeWidth={active ? 2 : 1.5} />
              </div>
              <span className={`text-xs font-medium ${active ? 'text-slate-900' : 'text-slate-500'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
